import { lng as de } from "../languages/de.language";
import { lng as en } from "../languages/en.language";
export const CustomLanguages: object = { "de": de, "en": en };
